import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  useDisclosure,
  Flex,
  Avatar,
  Stack,
  Text,
  Divider,
  MenuItem,
  IconButton,
  useColorModeValue,
  useClipboard,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { COLORS } from "../constants/colors";
import { BiCopy, BiCheck } from "react-icons/bi";

export const GuestDetailsModal = (props) => {
  const cardBg = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const whiteCol = useColorModeValue(COLORS.primary, COLORS.lightGrey);
  const detailsCardBg = useColorModeValue(COLORS.white, COLORS.darkGrey);
    const menuColor = useColorModeValue(COLORS.black, COLORS.white);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { hasCopied, onCopy } = useClipboard(props.guestCode || "");



  return (
    <Box>
      <MenuItem onClick={onOpen} color={menuColor}>
        View Details
      </MenuItem>
      <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalBody borderRadius=".8rem">
            <Box my="30px">
              <Flex align="center">
                <Avatar name={props.name} size="lg" />

                <Stack pl="10px">
                  <Text color={'#2b2469'} fontSize="lg">
                    {props.name}
                  </Text>
                  <Text color={whiteCol} fontSize="md">
                    {props.phone}
                  </Text>
                  <Flex>
                    <Text color="#2b2469" fontSize="x-small">
                      Created:
                    </Text>
                    <Text color="#B7B6B6" fontSize="x-small" pl="5px">
                      {dayjs(props.createdAt).format("DD/MMM/YYYY")}
                    </Text>
                    <Text color="#2b2469" fontSize="x-small" pl="5px">
                      Updated:
                    </Text>
                    <Text color="#B7B6B6" fontSize="x-small" pl="5px">
                      {dayjs(props.updateAt).format("DD/MMM/YYYY")}
                    </Text>
                  </Flex>
                  <Divider orientation="horizontal" color="#FAF6FF" />
                </Stack>
              </Flex>
              <Divider />
              <Box
                display="flex"
                flexDirection="column"
                gap="1rem"
                bg={detailsCardBg}
                p="5"
                borderRadius="lg"
                my="40px"
                color={cardBg}
              >
                <Flex width="100%" justify="space-between">
                  <Text fontSize="sm" color={'#2b2469'}>Start date</Text>
                  <Text color={whiteCol} fontSize="md">
                    {dayjs(props.startDate).format("DD/MM/YYYY")}
                  </Text>
                </Flex>
                <Flex width="100%" justify="space-between">
                  <Text fontSize="sm" color={'#2b2469'}>End date</Text>
                  <Text color={whiteCol} fontSize="md">
                    {dayjs(props.endDate).format("DD/MM/YYYY")}
                  </Text>
                </Flex>
                <Flex width="100%" justify="space-between">
                  <Text fontSize="sm" color={'#2b2469'}>Status</Text>
                  <Text
                    color="#F98B88"
                    fontSize="xs"
                    bg="#FAF6FF"
                    borderRadius="full"
                    p="3px 12px"
                  >
                    {props.status}
                  </Text>
                </Flex>

                <Flex justify="space-between" align="center">
                  <Text fontSize="sm" color={'#2b2469'}>Guest Code</Text>
                  <Flex align="center" gap="6px">
                    <Text color={whiteCol} fontSize="md">
                      {props.guestCode}
                    </Text>
                    <IconButton
                      size="xs"
                      variant="ghost"
                      aria-label="Copy guest code"
                      icon={hasCopied ? <BiCheck size="1rem" color="green" /> : <BiCopy size="1rem" />}
                      onClick={onCopy}
                    />
                  </Flex>
                </Flex>
                <Flex justify="space-between" align="center" color={whiteCol}>
                  <Text>One Time Visit</Text>
                  {props.oneTimeVisit ? (
                    <Text>Yes</Text>
                  ) : (
                    <Text color={whiteCol}>No</Text>
                  )}
                </Flex>

                <Flex justify="space-between" align="center" color={whiteCol}>
                  <Text>Allow Company</Text>
                  {props.allowCompany ? (
                    <Text>Yes</Text>
                  ) : (
                    <Text color={whiteCol}>No</Text>
                  )}
                </Flex>
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};